// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"06ce88c6","488":"84164a4a","977":"9aa533ad"}[chunkId] + ".chunk.js";
};